import { syncUrlWithMapState, FILTER_CONFIG } from "./map_state";
import { initializeSpotsLayer } from "./map_layer";
import { logger } from "./utils/logger";

/**
 * Setup all event bindings for the map
 * @param {Object} config - Configuration object
 * @param {mapboxgl.Map} config.map - Mapbox map instance
 * @param {Object} config.modeController - Mode controller with applyMode and getCurrentMode methods
 * @param {Object} config.spotsListController - Spots list controller with refreshVisibleSpots method
 * @param {Object} config.popupController - Popup controller with handleSpotsSymbolClick method
 * @param {string} config.tilesetId - Tileset ID
 * @param {string} config.sourceLayer - Source layer name
 * @param {Object} config.icons - Icons object
 */
export function setupMapEventBindings(config) {
  const {
    map,
    modeController,
    spotsListController,
    popupController,
    tilesetId,
    sourceLayer,
    icons,
    shouldSyncUrl = true
  } = config;

  const handleViewportChanged = () => {
    if (shouldSyncUrl) {
      const nextUrl = syncUrlWithMapState(map, window.location.href);
      window.history.replaceState({}, "", nextUrl);
    }
    spotsListController.refreshVisibleSpots();
  };

  // Moveend event: sync URL and refresh spots when viewport changes
  map.on("moveend", handleViewportChanged);

  // Filter-mode radio change event: apply mode to map filter
  document.querySelectorAll('input[name="filter-mode"]').forEach((input) => {
    input.addEventListener("change", (event) => {
      modeController.applyMode(event.target.value);
    });
  });

  // Map load event: initialize layer and perform initial viewport sync
  map.on("load", async () => {
    try {
      const currentMode = modeController.getCurrentMode();
      await initializeSpotsLayer({
        map,
        tilesetId,
        sourceLayer,
        icons,
        filter: FILTER_CONFIG[currentMode].mapFilter,
        onSymbolClick: (event) => popupController.handleSpotsSymbolClick(event)
      });
    } catch (error) {
      logger.error(error);
    }

    handleViewportChanged();
  });
}
